import { disableBodyScroll, enableBodyScroll, clearAllBodyScrollLocks, BodyScrollOptions } from 'body-scroll-lock';

var modal = {
	selectors: {
		element: '[data-modal]',
		trigger: '[data-modal-trigger]',
		close: '[data-modal-close]',
		activeInner: {}, 
	},
	init: function () {
		var self = this;

		jQuery(document.body).on('click', self.selectors.trigger, function (event) {
			event.preventDefault();

			var $this = jQuery(this);
			var findInner = $this.attr('data-modal-trigger');
			var inner = document.querySelector('.modal__inner--' + findInner);

			jQuery('.modal__inner.inner-active').removeClass('inner-active');
			
			setTimeout(() => {
				inner.classList.add('inner-active');

				self.selectors.activeInner = inner;
				document.querySelector('.modal__content').classList.add(findInner);

				disableBodyScroll(self.selectors.activeInner, {
					reserveScrollBarGap: true,
				});
				
				jQuery(document.body).addClass('modal-opened');
			}, 20);

			setTimeout(function () {
				$this.blur();
				jQuery(document.body).focus();
			}, 150);

			return false;
		});

		jQuery(self.selectors.element).on('click', self.selectors.close, function (e) {
			e.preventDefault();

			enableBodyScroll(self.selectors.activeInner);
			clearAllBodyScrollLocks();

			jQuery(document.body).removeClass('modal-opened');
			jQuery('.inner-active').removeClass('inner-active');

			jQuery('.modal__content').attr('class', 'modal__content');

			self.selectors.activeInner = {};

			return false;
		});
	},
};

export { modal };
